export const groupTypes = Object.freeze({
  UNI: 'uni',
  INSTITUTIONAL: 'institutional',
  MUNICIPAL: 'municipal',
  CROSS_INSTITUTIONAL: 'cross_institutional',
});
